import styled from 'styled-components';
import { Affix as affix } from 'antd';

const Affix = styled(affix)``;

/** @component */
export default Affix;
